import ApiService from "../apiService";
import { get } from "../apiService";
const _ = require("lodash");
const model = "locations";

export default class LocationService extends ApiService {
  findAll(searchTerm) {
    return get(`/${model}`, {
      params: {
        "filter[search]": searchTerm
      }
    });
  }

  find(id) {
    return get(`/${model}/${id}`, {
      params: {}
    });
  }

  save(item) {
    return this.baseSave(model, item);
  }

  archive(item) {
    return this.baseArchive(model, item);
  }
}



// WEBPACK FOOTER //
// ./src/services/locationService/index.js